import { render, staticRenderFns } from "./SetCredentials.vue?vue&type=template&id=c7954410"
import script from "./SetCredentials.vue?vue&type=script&lang=js"
export * from "./SetCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports